export const memberSources = [
  {
    label: 'Linkedin',
    value: 1,
  },
  {
    label: 'Instagram',
    value: 2,
  },
  {
    label: 'Job Post',
    value: 3,
  },
  {
    label: 'Facebook',
    value: 4,
  },
  {
    label: 'Reference',
    value: 5,
  },
  {
    label: 'Other',
    value: 6,
  },
];
